var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHardscapeLil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_16782)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.333 17.6641H5.33301V9.66406H21.333V17.6641ZM29.333 17.6641V25.6641H21.333V33.6641H37.333V17.6641H29.333Z",
    fill: "#C43338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3328 8.33203H5.33285C4.97922 8.33203 4.64008 8.47251 4.39004 8.72256C4.13999 8.9726 3.99951 9.31174 3.99951 9.66536V33.6654C3.99951 34.019 4.13999 34.3581 4.39004 34.6082C4.64008 34.8582 4.97922 34.9987 5.33285 34.9987H37.3328C37.6865 34.9987 38.0256 34.8582 38.2757 34.6082C38.5257 34.3581 38.6662 34.019 38.6662 33.6654V9.66536C38.6662 9.31174 38.5257 8.9726 38.2757 8.72256C38.0256 8.47251 37.6865 8.33203 37.3328 8.33203ZM14.6662 24.332V18.9987H27.9995V24.332H14.6662ZM6.66618 24.332V18.9987H11.9995V24.332H6.66618ZM30.6662 18.9987H35.9995V24.332H30.6662V18.9987ZM35.9995 16.332H22.6662V10.9987H35.9995V16.332ZM19.9995 10.9987V16.332H6.66618V10.9987H19.9995ZM6.66618 26.9987H19.9995V32.332H6.66618V26.9987ZM22.6662 32.332V26.9987H35.9995V32.332H22.6662Z",
    fill: "#C43338"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_16782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6667,
    height: 42.6667,
    fill: "white",
    transform: "translate(0.33252 0.664062)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardscapeLil);
export default __webpack_public_path__ + "static/media/hardscapeLil.bdc26275d2665b86f91d4af300803b7d.svg";
export { ForwardRef as ReactComponent };